

import __layout_0 from '/app/app/frontend/layouts/default.vue'
export const layouts = {
'blank': () => import('/app/app/frontend/layouts/blank.vue'),
'default': __layout_0,
'components/Command': () => import('/app/app/frontend/layouts/components/Command.vue'),
'components/DefaultLayout': () => import('/app/app/frontend/layouts/components/DefaultLayout.vue'),
'components/NavGroup': () => import('/app/app/frontend/layouts/components/NavGroup.vue'),
'components/NavLink': () => import('/app/app/frontend/layouts/components/NavLink.vue'),
'components/ThemeMenu': () => import('/app/app/frontend/layouts/components/ThemeMenu.vue'),
'components/UserMenu': () => import('/app/app/frontend/layouts/components/UserMenu.vue'),
}
export const createGetRoutes = (router, withLayout = false) => {
  const routes = router.getRoutes()
  if (withLayout) {
      return routes
  }
  return () => routes.filter(route => !route.meta.isLayout)
}

export function setupLayouts(routes) {
  function deepSetupLayout(routes, top = true) {
    return routes.map(route => {
      if (route.children?.length > 0) {
        route.children = deepSetupLayout(route.children, false)
      }
      
      if (top) {
        // unplugin-vue-router adds a top-level route to the routing group, which we should skip.
        const skipLayout = !route.component && route.children?.find(r => (r.path === '' || r.path === '/') && r.meta?.isLayout)  

        if (skipLayout) {
          return route
        }

        if (route.meta?.layout !== false) {
          return { 
            path: route.path,
            component: layouts[route.meta?.layout || 'default'],
            children: route.path === '/' ? [route] : [{...route, path: ''}],
            meta: {
              isLayout: true
            }
          }
        }
      }

      if (route.meta?.layout) {
        return { 
          path: route.path,
          component: layouts[route.meta?.layout],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      return route
    })
  }

    return deepSetupLayout(routes)

}
